import { httpClient } from "../http";

export class NormScalesHttpService {
  static async getNormScales(normId: number) {
    const { data: normScales } = await httpClient.get(`/api/norms/${normId}/scales`);

    return normScales;
  }
}
